export default __webpack_public_path__ + "static/trends-breakdown-light-mode-76c4d88a3525c7ce8febbac8c004e0d3.png";